import { FieldValidator } from './field-validator'

export class EmailAddressTextFieldValidator implements FieldValidator<string> {
    unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
    //rfc_5322_official_email_regex = new RegExp('/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/')
    //`^` +
    //`(` +
    //`?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"` +
    //`${this.unicodeRange}*"` +
    //`)` +
    //`@` +
    //`(` +
    //`?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+` +
    //`[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|` +
    //`\\[` +
    //`(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}` +
    //`(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:${this.unicodeRange}+)` +
    //`\\]` +
    //`)` +
    //`$`

    constructor(private isOptional = false) {}

    validate(text: string, fieldName: string): Promise<string> {
        const invalidEmailAddressMessage = `Email address must contain '@' and '.'`

        const isUndefined: boolean = !text
        const isEmpty: boolean = !!text && text.length === 0

        return new Promise((resolve, reject) => {
            if (this.isOptional && (isUndefined || isEmpty)) {
                resolve('')
            } else if (!this.isValidEmail(text)) {
                reject(invalidEmailAddressMessage)
            } else {
                resolve('')
            }
        })
    }

    //private isValidEmailAddress(text: string): boolean {
    //    return this.rfc_5322_official_email_regex.test(text)
    //}
    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
}
